import React from 'react';
import { Link } from 'react-router-dom';
const CTASection = () => {
  return <div id="signup" className="relative bg-primary overflow-hidden" data-id="element-71">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-primary pointer-events-none" data-id="element-72"></div>

      <div className="relative max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8 lg:flex lg:items-center lg:justify-between" data-id="element-73">
        <div data-id="element-74">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-75">
            <span className="block" data-id="element-76">Ready to own AI search?</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-textlight max-w-2xl" data-id="element-77">
            Join leading brands already optimizing for the future of search.
          </p>
        </div>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0" data-id="element-78">
          <div className="inline-flex rounded-lg shadow-lg" data-id="element-79">
            <Link to="/demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg text-primary bg-white hover:bg-gray-50 transition-all duration-150" data-id="element-80">
              Book a Demo
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default CTASection;